import React, { useState } from 'react';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import { useTranslation } from 'react-i18next';


const CustomDatePicker = (props) => {
    const [selectedDate, setSelectedDate] = useState(null);
    const { t } = useTranslation('other');
    return (
        <MuiPickersUtilsProvider utils={MomentUtils}>
            <DatePicker clearLabel={t('ponisti')} clearable cancelLabel={t('odustani')} value={selectedDate}
                onChange={(event) => {
                    if (event != null) {
                        event = event.toDate()
                    }

                    setSelectedDate(event);
                    props.onFilterChanged(props.columnDef.tableData.id, event);
                }}
                format="DD.MM.YYYY"
                style={{ width: "100px" }}
            />
        </MuiPickersUtilsProvider>
    )
}

export default CustomDatePicker;
